const DAY = /^\d{4}-\d{2}-\d{2}$/;
export function today() {
    return toDay(new Date());
}
/**
 * Convierte a día, en horario local.
 *
 * `toISOString()` convierte a UTC, así que a las 23:30 de Madrid en verano
 * devolvería el día siguiente. Un pedido saltaría de semana según la hora a la
 * que se lanzara el plan.
 */
export function toDay(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
/** Lee una fecha de SAP (`2026-09-20T00:00:00Z` o `2026-09-20`). Null si no hay. */
export function dayFromSap(raw) {
    if (!raw)
        return null;
    const text = String(raw).slice(0, 10);
    return DAY.test(text) ? text : null;
}
export function addDays(day, days) {
    const [y, m, d] = day.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    date.setDate(date.getDate() + days);
    return toDay(date);
}
/** Días de `a` a `b`. Negativo si `b` es anterior. */
export function daysBetween(a, b) {
    const [ay, am, ad] = a.split('-').map(Number);
    const [by, bm, bd] = b.split('-').map(Number);
    // UTC a propósito: aquí solo se restan dos fechas ya normalizadas, y en UTC
    // no hay días de 23 ni de 25 horas que descuadren la resta.
    const ms = Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad);
    return Math.round(ms / 86_400_000);
}
export function maxDay(a, b) {
    return a >= b ? a : b;
}
/** Lunes de la semana de `day`. La semana empieza en lunes, como la fábrica. */
export function startOfWeek(day) {
    const [y, m, d] = day.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    const dow = (date.getDay() + 6) % 7;
    return addDays(day, -dow);
}
export function startOfMonth(day) {
    return `${day.slice(0, 7)}-01`;
}
/**
 * Los cubos que cubren el horizonte, empezando en `from`.
 *
 * El primer cubo empieza SIEMPRE en `from` aunque el cubo sea semanal y `from`
 * sea jueves: un cubo que empezara el lunes anterior incluiría demanda ya
 * pasada y el stock proyectado saldría mal.
 */
export function buildBuckets(from, horizonDays, size) {
    const end = addDays(from, horizonDays);
    const out = [];
    let cursor = from;
    while (cursor < end) {
        let next;
        if (size === 'day')
            next = addDays(cursor, 1);
        else if (size === 'week')
            next = addDays(startOfWeek(cursor), 7);
        else {
            const [y, m] = cursor.split('-').map(Number);
            next = m === 12 ? `${y + 1}-01-01` : `${y}-${String(m + 1).padStart(2, '0')}-01`;
        }
        if (next > end)
            next = end;
        out.push({ from: cursor, to: addDays(next, -1) });
        cursor = next;
    }
    return out;
}
//# sourceMappingURL=dates.js.map